const homeNews = {
    mixins: [mixins],
    data() {
        return {
            // default
            $this: [],
            isLoading: false,       

            handler:null,
            isMobile: false,
            featuredArticles:[],
            listArticles:[],

            slickOptions: {
                lazyLoad: 'progressive',
                edgeFriction: api.vars.slick.edgeFriction,
                infinite: false,
                arrows: false,
                dots: true,
                rows: 0,
                slidesToShow: 1,
                fade: true,
                cssEase: 'linear',
                autoplay: true,
                autoplaySpeed: 6000,
                responsive: [
                    {
                        breakpoint: api.vars.scr.tablet - 1,
                        settings: {
                            edgeFriction: api.vars.slick.edgeFriction,                           
                            slidesToShow: 1,  
                            fade: false,
                            variableWidth:true,
                            autoplay: false,
                            dots:false
                        },
                    }                   
                ],               
            },

            slickListOptions: {
                responsive: [
                    {
                        breakpoint: api.vars.scr.tablet - 1,
                        settings: {
                            edgeFriction: api.vars.slick.edgeFriction,
                            infinite: true,
                            arrows: false,
                            dots: true,
                            variableWidth:true,
                            rows: 0,
                            slidesToShow: 1,
                            autoplay: true
                        },
                    }                   
                ],
                               
            },

            // server error dialog
            errorMsgs: [],
        }
    },
   
    mounted(){
        
        api.fn.getWindDims();

        this.appendDotsToSlicks()

        this.$nextTick(() => {

            this.checkMobileScreen()
    
            jQuery(document).on("window-resized", ()=> {
                this.checkMobileScreen()
            })
          
            this.fetchArticles()
        });
    },

    methods:{

        appendDotsToSlicks(){

            this.slickOptions.responsive[0].settings.appendDots = jQuery(this.$el).find(".feature-slick-dots")
            
            this.slickListOptions.responsive[0].settings.appendDots = jQuery(this.$el).find(".list-slick-dots")

        },

        checkMobileScreen (){   
            this.isMobile = api.vars.windW < api.vars.scr.tablet - 1;
        },

        fetchArticles: function () {
            this.isLoading = true;

            axios
                .post(this.handler)
                .then((response) => {                    

                    // response has error
                     if (response.data.hasError) {
                        this.handleError(errorMessages);
                        return false;
                     }                  

                    this.featuredArticles = response.data.data.records.filter(i => i.isFeatured == "true")                                                                                          
                    this.listArticles = response.data.data.records.filter(i => i.isFeatured == "false") 

                    this.$nextTick(function(){                                   
                        this.$refs.news.reSlick() 
                        if(this.$refs.newslist)
                            this.$refs.newslist.reSlick()                       
                     })

                    // Dom actions
                    this.isLoading = false;
                })
                .catch((errors) => {
                    this.handleError([errors]);
                   // console.error(errors);
                });
        },

        handleError: function (messages) {
			this.errorMsgs = this.hasValue(messages) ? messages : []
			this.isLoading = false
		},
     
        
    }
}

let homeNewsApp = [];
const homeNewsDivs = document.querySelectorAll(".s-news-home");
if (homeNewsDivs.length) {
    for (let i = 0; i < homeNewsDivs.length; ++i) {
		if (homeNewsDivs[i].id && homeNewsDivs[i].id !== "") {
			homeNewsApp.push(Vue.createApp({...homeNews}));
            homeNewsApp[i].component("alert-danger", alertDanger)
            homeNewsApp[i].component("slick-carousel", slickCarousel)
			homeNewsApp[i].directive('init', initDirective);
			homeNewsApp[i].mount(`#${homeNewsDivs[i].id}`);
		}
	}
}
// const newsApp = Vue.createApp(homeNews)
// newsApp.directive('init', initDirective);
// if(document.querySelector("#home-news"))
//     newsApp.mount('#home-news')